import { render } from "./AddressView.vue?vue&type=template&id=370722f1&scoped=true"
import script from "./AddressView.vue?vue&type=script&lang=js"
export * from "./AddressView.vue?vue&type=script&lang=js"

import "./AddressView.vue?vue&type=style&index=0&id=370722f1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370722f1"]])

export default __exports__